import { Injectable } from "@angular/core";
import {
    HttpClient,
    HttpHeaders,
    HttpErrorResponse,
} from "@angular/common/http";
import {
    Platform,
    AlertController,
    ToastController,
    LoadingController,
} from "@ionic/angular";
import {
    InAppBrowser,
    InAppBrowserOptions,
} from "@ionic-native/in-app-browser/ngx";
import { BehaviorSubject, ReplaySubject, throwError } from "rxjs";
import { environment } from "../../environments/environment";
import CryptoJS from "crypto-js";

@Injectable({
    providedIn: "root",
})
export class UtilService {
    private loading;
    private alert;
    private lastHash;

    public backendUrl;

    public bleEvent$ = new ReplaySubject(1);
    public sbpmDevice$ = new BehaviorSubject({
        serialNum: "HCB20168",
        bleId: null,
        deviceId: null,
        btnPressed: 0,
        temperature: 0,
    });
    public oso2Event$ = new ReplaySubject(1);
    public tempMeasurePos$ = new BehaviorSubject(null);

    constructor(
        private plt: Platform,
        private http: HttpClient,
        private alertCtrl: AlertController,
        public toastCtrl: ToastController,
        private loadingCtrl: LoadingController,
        private inAppBrowser: InAppBrowser
    ) {
        this.backendUrl = environment.baseUrl;
    }
    val(x) {
        return x ? x : "";
    }
    valNum(x) {
        return isNaN(x) ? "" : x;
    }
    formatUUID(t) {
        return t.startsWith("0x") ? parseInt(t) : /^[0-9a-fA-F]+$/.test(t) ? parseInt(t, 16) : t
    }
    getSBPMDevice() {
        return (
            this.sbpmDevice$.value.serialNum +
            "^" +
            this.sbpmDevice$.value.bleId +
            "^" +
            this.sbpmDevice$.value.deviceId +
            "^" +
            this.sbpmDevice$.value.btnPressed
        );
    }
    /*
    Child body fat %
    1.51*BMI - 0.70*Age - 3.6*sex + 1.4
    Adult body fat %
    1.20*BMI + 0.23*Age - 10.8*sex - 5.4
    (1.39 x BMI) + (0.16 x age) - (10.34 x gender) - 9, 
    with gender equal to 1 for men and 0 for women to account for the lower body fat percentage of men
    
    
    Body fat % = –44.988 + (0.503 * age) + (10.689 * gender) + (3.172 * BMI) – (0.026 * BMI2) + (0.181 * BMI * gender) – (0.02 * BMI * age) – (0.005 * BMI2 * gender) + (0.00021 * BMI2 * age)
    Gender value: male = 0 and female = 1
    BMI = weight/ height² = kg/m²
    */
    getBMIBF(gender, height, weight, birthYear) {
        let bmi, bf, sex, age;
        bmi = "";
        bf = "";
        age = new Date().getFullYear() - parseInt(birthYear);
        sex = gender == "fe" ? 0 : 1;
        height = parseInt(height);
        weight = parseInt(weight);
        if (height > 50 && weight > 20 && gender != "df") {
            bmi = height / 100; //cm to m
            bmi = weight / (bmi * bmi);
            bf = 1.39 * bmi + 0.16 * age - 10.34 * sex - 9;
            bmi = Math.round(bmi * 10) / 10;
            bf = Math.round(bf * 10) / 10;
        }
        return { BMI: bmi, BF: bf, Age: age };
    }

    createCheckCode() {
        let t = Date.now();
        let h;
        h = CryptoJS.SHA256("OSO2#686868#" + t);
        h = h.toString(CryptoJS.enc.Base64);
        console.log(h);
        return { t: "" + t, h: "" + h };
    }

    hashCodeString(str, length) {
        let hash = 5381;
        let i, temp;
        if (str.length == 0) return hash;
        for (i = 0; i < str.length; i++) {
            temp = str.charCodeAt(i);
            hash = (hash << 5) + hash + temp;
            hash = hash & hash; // Convert to 32bit integer
        }
        hash = hash >>> 0; //Conver to 32bit unsigned integer
        temp = Math.pow(10, length);
        hash = hash % temp;
        temp = hash + "";
        while (temp.length < length) {
            temp = "0" + temp;
        }
        return temp;
    }
    hashCodeStringNull(str, length) {
        let hash = 5381;
        let i, temp;
        if (str.length == 0) return hash;
        for (i = 0; i < str.length; i++) {
            temp = str.charCodeAt(i);
            hash = (hash << 5) + hash + temp;
            hash = hash & hash; // Convert to 32bit integer
        }
        hash = hash >>> 0; //Conver to 32bit unsigned integer
        temp = Math.pow(10, length);
        hash = hash % temp;
        temp = hash + "";
        while (temp.length < length) {
            temp = "0" + temp;
        }
        if (temp != this.lastHash) {
            this.lastHash = temp;
            return temp;
        } else {
            return null;
        }
    }
    removeVietnameseTones(str) {
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/đ/g, "d");
        str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
        str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
        str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
        str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
        str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
        str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
        str = str.replace(/Đ/g, "D");
        // Some system encode vietnamese combining accent as individual utf-8 characters
        // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
        str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
        str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
        // Remove extra spaces
        // Bỏ các khoảng trắng liền nhau
        str = str.replace(/ + /g, " ");
        str = str.trim();
        // Remove punctuations
        // Bỏ dấu câu, kí tự đặc biệt
        str = str.replace(
            /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
            " "
        );
        return str;
    }
    date2string(date, mode) {
        let hours = date.getHours();
        let ampm = hours >= 12 ? "PM" : "AM";
        if (mode === 1) {
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
        }
        //"ddMMyyhhmmss"
        let t_id =
            date.getFullYear() +
            "" +
            (date.getMonth() < 9
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1) +
            "" +
            (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
            "" +
            (hours < 10 ? "0" + hours : hours) +
            "" +
            (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
            "" +
            (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
        if (mode == 0) {
            //24h
            return t_id;
        } else if (mode == 1) {
            //12h
            return t_id + ampm;
        } else {
            //full

            t_id =
                (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
                "/" +
                (date.getMonth() < 9
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) +
                "/" +
                date.getFullYear() +
                " " +
                (hours < 10 ? "0" + hours : hours) +
                ":" +
                (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
                ":" +
                (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
            return t_id;
        }
    }

    gotoOutLink(url) {
        let options: InAppBrowserOptions = {
            zoom: "yes",
            enableViewportScale: "yes",
        };
        console.log(url);
        let browser;
        if (this.plt.is("ios")) {
            options.location = "no";
            //browser = this.inAppBrowser.create(url, "_system", options);
            browser = this.inAppBrowser.create(url, "_blank", options);
        } else {
            browser = this.inAppBrowser.create(url, "_blank", options);
        }
    }

    // Handle API errors
    handleError(error: HttpErrorResponse) {
        let ms;
        let status;
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error("An error occurred:", error.error.message);
            ms = "Network error!, Please check your Internet Connection!";
            status = 0;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            ms = JSON.stringify(error.error);
            status = error.status;
            console.error(`Backend returned code ${status}, ` + `body was: ${ms}`);
        }
        // return an observable with a user-facing error message
        return throwError({ message: ms, code: status });
    }

    titleCaseWord(word: string) {
        if (!word) return word;
        return word
            .split(" ")
            .map((w) => {
                return w[0].toUpperCase() + w.substr(1).toLowerCase();
            })
            .join(" ");
    }

    async presentToast(ms) {
        const toast = await this.toastCtrl.create({
            message: ms, // 'Your settings have been saved.',
            duration: 3000,
        });
        await toast.present();
    }
    async presentToast_long(ms) {
        const toast = await this.toastCtrl.create({
            message: ms, // 'Your settings have been saved.',
            duration: 8000,
        });
        await toast.present();
    }
    async presentLoading(msg, ms?) {
        if (this.loading) {
            await this.loading.dismiss();
        }
        this.loading = await this.loadingCtrl.create({
            message: msg,
            duration: ms ? ms : 3000,
        });
        await this.loading.present();
    }
    async closeLoading() {
        if (this.loading) {
            await this.loading.dismiss();
        }
    }
    async presentAlert(title, msg) {
        if (this.alert) {
            await this.alert.dismiss();
        }
        this.alert = await this.alertCtrl.create({
            header: title,
            message: msg,
            buttons: ["OK"],
        });
        await this.alert.present();
    }
}
